import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { AuthComponent } from './pages/auth/auth.component';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CarouselWalletComponent } from './components/carousel-wallet/carousel-wallet.component';
import { MailValidationComponent } from './components/mail-validation/mail-validation.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { RequestPasswordResetComponent } from './components/request-password-reset/request-password-reset.component';
import { LogoutCountdownComponent } from './components/logout-countdown/logout-countdown.component';
import { AfterLoginComponent } from './components/after-login/after-login.component';
import { SignInAcComponent } from './components/sign-in-ac/sign-in-ac.component';

// Dinamic Signup Components
import { DinamicSignupComponent } from './components/dinamic-signup/dinamic-signup.component';
import { AccountTypeStepComponent } from './components/dinamic-signup/components/account-type-step/account-type-step.component';
import { RegistrationFormStepComponent } from './components/dinamic-signup/components/registration-form-step/registration-form-step.component';
import { EmailOtpStepComponent } from './components/dinamic-signup/components/email-otp-step/email-otp-step.component';
import { WhatsappOtpStepComponent } from './components/dinamic-signup/components/whatsapp-otp-step/whatsapp-otp-step.component';
import { OcrDocumentStepComponent } from './components/dinamic-signup/components/ocr-document-step/ocr-document-step.component';
import { FaceCaptureStepComponent } from './components/dinamic-signup/components/face-capture-step/face-capture-step.component';
import { DataConfirmationStepComponent } from './components/dinamic-signup/components/data-confirmation-step/data-confirmation-step.component';
import { PepSelectionStepComponent } from './components/dinamic-signup/components/pep-selection-step/pep-selection-step.component';
import { PepDeclarationStepComponent } from './components/dinamic-signup/components/pep-declaration-step/pep-declaration-step.component';
import { EmpresaConsentStepComponent } from './components/dinamic-signup/components/empresa-consent-step/empresa-consent-step.component';
import { ErutUploadStepComponent } from './components/dinamic-signup/components/erut-upload-step/erut-upload-step.component';
import { RepresentanteLegalStepComponent } from './components/dinamic-signup/components/representante-legal-step/representante-legal-step.component';
import { RepresentantePepStepComponent } from './components/dinamic-signup/components/representante-pep-step/representante-pep-step.component';
import { PersonaJuridicaStepComponent } from './components/dinamic-signup/components/persona-juridica-step/persona-juridica-step.component';
import { InformacionNegocioStepComponent } from './components/dinamic-signup/components/informacion-negocio-step/informacion-negocio-step.component';
import { OtpInputComponent } from './components/dinamic-signup/components/shared/otp-input/otp-input.component';
import { PasswordRulesChecklistComponent } from './components/dinamic-signup/components/shared/password-rules-checklist/password-rules-checklist.component';

// Angular Material
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    SignInComponent,
    AuthComponent,
    CarouselWalletComponent,
    MailValidationComponent,
    PasswordResetComponent,
    RequestPasswordResetComponent,
    LogoutCountdownComponent,
    AfterLoginComponent,
    SignInAcComponent,
    DinamicSignupComponent,
    AccountTypeStepComponent,
    RegistrationFormStepComponent,
    EmailOtpStepComponent,
    WhatsappOtpStepComponent,
    OcrDocumentStepComponent,
    FaceCaptureStepComponent,
    DataConfirmationStepComponent,
    PepSelectionStepComponent,
    PepDeclarationStepComponent,
    EmpresaConsentStepComponent,
    ErutUploadStepComponent,
    RepresentanteLegalStepComponent,
    RepresentantePepStepComponent,
    PersonaJuridicaStepComponent,
    InformacionNegocioStepComponent,
    OtpInputComponent,
    PasswordRulesChecklistComponent,
  ],
  imports: [CommonModule, AuthRoutingModule, SharedModule, MatIconModule],
})
export class AuthModule {}
